/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Group, CTAs } from '@insticator/insticator-ui'; // iui-material
import BackToEmbedsCTA from 'material/ctas/backtoembeds/backtoembeds';
import EmbedName from 'material/embeds/embedname/embedname_container';
import Preview from 'material/ctas/preview/preview_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedcontrols/embedcontrols_styles';



/* ========== ~~~~~~~~~~ EMBED CONTROLS ~~~~~~~~~~ ========== */
const EmbedControls = (props) => {
	const _renderCTAs = () => {
		const ctas =
				(<Group>
					<CTAs>
						<Preview />
					</CTAs>
				</Group>);
        return props.currentStepPage !== 'placement' || !props.isNewEmbedFlow ? ctas : null;
    };
	return (
		<div className={`embedcontrols ${props.classes.embedcontrols} embedChangeDetected-${!props.isNewEmbedFlow && props.changeDetected}`}>
			<Group>
				<BackToEmbedsCTA />
			</Group>
			<Group>
        		<EmbedName handleSaveEmbed={props.handleSaveEmbed} />
        	</Group>
			{_renderCTAs()}
        </div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EmbedControls);
